import { Pagination } from '@heroui/react';
import { OnChangeFn, PaginationState } from '@tanstack/react-table';
import styles from './TableFooter.module.scss';

interface TableFooterProps {
  total: number;
  pagination: PaginationState;
  setPagination: OnChangeFn<PaginationState>;
}

export const TableFooter = ({ total, pagination, setPagination }: TableFooterProps) => (
  <div className={styles.root}>
    <Pagination
      size="sm"
      variant="light"
      total={total}
      page={pagination.pageIndex}
      onChange={(page) => setPagination({ ...pagination, pageIndex: page })}
      classNames={{
        wrapper: styles.wrapperPagination,
        cursor: styles.paginationCursor,
        item: styles.paginationItem,
        prev: styles.paginationControl,
        next: styles.paginationControl,
      }}
      showControls
      isCompact
    />
  </div>
);
